<template>
  <div>Establish connection...</div>
</template>

<script>

import { http } from '../api'

export default {
  name: 'Connector',

  created () {

    const state = JSON.parse(this.$route.query.state)

    const payload = {
      code: this.$route.query.code,
      name: 'google-ads'
    }

    http({
      method: 'post',
      url: `accounts/${state.accountId}/connections`,
      data: payload
    }).then(() => {
      this.$router.push({ path: '/' })
    })

  }

}

</script>
